import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OrderPayComponent } from './order-pay.component';

@NgModule({
    imports: [
        CommonModule],
    declarations: [
        OrderPayComponent
    ],
    exports: [
        OrderPayComponent
    ]
})
export class OrderPayInModule {

}
